class TrainingViewModel {
    public componentName = ko.observable("");
    public componentParams = ko.observable({});
    public course = ko.observable("");
    public supplementalsLink = ko.observable("");
    public symitarLink = ko.observable("");
    public trainingLink1 = ko.observable("");
    public trainingLink2 = ko.observable("");
    public trainingLink3 = ko.observable("");
    constructor(params: any) {
        var self = this;
        let prefix = "";
        if (globals.navMode === "hasher") {
            prefix = "#";
        }
        this.supplementalsLink(prefix + "/training/supplementals");
        this.symitarLink(prefix + "/training/symitar");
        this.trainingLink1(prefix + "/training/training1");
        this.trainingLink2(prefix + "/training/training2");
        this.trainingLink3(prefix + "/training/training3");

        self.course(params.id || "");
        if (params.id) {
            self.componentName(params.id);
        }
        else {
            self.componentName("training1");
        }
    }

}

export default { viewModel: TrainingViewModel, template: require('./training.html') };